import React from 'react'
import noItemImg from '../../images/ban-no-item.png'
import { WKSearch, WKVisible } from '../../components/wk'


export default function (props) {
    return (
        <WKVisible create={props.show}>
            <div className="resell-page-empty">
                <img src={noItemImg} alt=""/>
                <span>{props.text || '暂无内容'}</span>
            </div>
        </WKVisible>
    )
}


// WEBPACK FOOTER //
// ./src/pages/resell/ResellNoItem.js